<template>
    <div class="fdw">
        <div class="middle_coment" v-for="(item,index) in list" :key="index">
            <div class="coment_left">
                <img :src="item.pic?item.pic:'http://zhiwubang-oss.oss-cn-beijing.aliyuncs.com/upload/20210907/208e3193a0ed47409c70cd2996be916e.png'" alt="">
            </div>
            <div class="coment_right">
                <p>{{item.name}}</p>
                <p>
                    <span>浏览 :</span><span>{{item.browseDate.substring(0,10)}}</span>
                </p>
                <p>
                    <span>电话 :</span><span>{{item.telphone}}</span>
                </p>
                <!-- <p>
                    <span>浏览 :</span><span>xxxxxx产品</span>
                </p> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        list:{
            type:Array
        }
    },
}
</script>
<style scoped>
.fdw{
  display: flex;
  justify-content: space-between;
}
.middle_coment{
    width: 48%;
    height: 138px;
    background: #F6F6F6;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
}
.coment_left{
    width: 35%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}
.coment_left img{
    width: 84px;
    height: 84px;
    background: #FFFFFF;
    border-radius: 50%;
    margin-left: 10px;
    transition: all 0.6s;
}
.coment_left img:hover{
   transform: scale(1.1);
}
.coment_right{
   width: 70%;
   text-align:left;
   padding: 31px 10px;
}
.coment_right p:first-child{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #343434;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.coment_right p{
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
    line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/pictureLeftList.vue